var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileMenuItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.561767 7.92224L13.2724 0.583746L13.2724 15.2607L0.561767 7.92224Z",
    fill: "url(#paint0_linear_86_370)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_370",
    x1: 0.561767,
    y1: 7.92224,
    x2: 17.5093,
    y2: 7.92224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuItem);
export default __webpack_public_path__ + "static/media/mobile-menu-item.7eb086c9947176417d5ed325d0358e7a.svg";
export { ForwardRef as ReactComponent };